import React, { useState } from "react";

import clsx from "clsx";
import { Link } from "react-router-dom";

import { useAuth0 } from "@components/auth0-wrapper";
import { CustomMetricsNewBadge } from "@features/custom-metrics/custom-metrics-modal";
import { useFeatureFlags } from "@hooks/http";
import { logEvent } from "@internal/analytics";
import { ContextMenu } from "@shared/context-menu";

const menuItemClasses = clsx(
  "cursor-pointer block py-2 pl-3 pr-4 text-inherit no-underline font-normal",
  "hover:bg-cosmic-4 flex items-center gap-2",
);

export const HeaderHamburgerMenu = () => {
  const { logout } = useAuth0();
  const { hasFeatureFlag } = useFeatureFlags();

  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    if (!isOpen) {
      logEvent("Open Hamburger Menu");
    }
    setIsOpen((prevState) => !prevState);
  };

  return (
    <ContextMenu
      menuClassName={clsx({
        "w-52": !hasFeatureFlag("showBreakdownV2NewBadge"),
        "w-[250px]": hasFeatureFlag("showBreakdownV2NewBadge"),
      })}
      menuPosition="bottom-left"
      menuButton={
        <ContextMenu.Button
          className={clsx(
            "cursor-pointer text-cosmic+2 hover:bg-cosmic-4 transform",
            "transition-colors ease-in ui-open:bg-cosmic-4 rounded-lg py-1 px-1.5",
          )}
          onClick={toggleDrawer}
        >
          {({ open }) => (
            <i
              className={clsx("w-4 h-4 fa-regular fa-sharp", {
                "fa-bars-staggered": open,
                "fa-bars": !open,
              })}
            />
          )}
        </ContextMenu.Button>
      }
    >
      <ContextMenu.Item
        className={menuItemClasses}
        as={Link}
        to="breakdowns"
        onClick={() => {
          toggleDrawer();
          logEvent("Open Breakdowns from Hamburger Menu");
        }}
      >
        <i className="fa-regular fa-list-tree text-cosmic w-5 text-center" />
        Manage Breakdowns
        {hasFeatureFlag("showBreakdownV2NewBadge") && (
          <CustomMetricsNewBadge className="ml-0.5" />
        )}
      </ContextMenu.Item>
      <ContextMenu.Item
        className={menuItemClasses}
        as={Link}
        to="model-comparison"
        onClick={() => {
          toggleDrawer();
          logEvent("Open Model Comparison from Hamburger Menu");
        }}
      >
        <i className="fa-regular fa-ruler text-cosmic w-5 text-center" />
        Model comparison
      </ContextMenu.Item>
      <ContextMenu.Item
        className={menuItemClasses}
        as={Link}
        to="customers/paths"
        onClick={() => {
          toggleDrawer();
          logEvent("Open Customer Paths from Hamburger Menu");
        }}
      >
        <i className="fa-regular fa-road text-cosmic w-5 text-center" />
        Customer paths
      </ContextMenu.Item>
      <ContextMenu.Item
        className={menuItemClasses}
        as={Link}
        to="guides"
        onClick={() => {
          toggleDrawer();
          logEvent("Open Guides from Hamburger Menu");
        }}
      >
        <i className="fa-regular fa-info-square text-cosmic w-5 text-center" />
        Guides
      </ContextMenu.Item>
      <ContextMenu.Item
        className={menuItemClasses}
        as={Link}
        to="customers/documents"
        onClick={() => {
          toggleDrawer();
          logEvent("Open documents from Hamburger Menu");
        }}
      >
        <i className="fa-regular fa-file text-cosmic w-5 text-center" />
        Documents
      </ContextMenu.Item>
      <ContextMenu.Item
        className={menuItemClasses}
        as="div"
        onClick={() =>
          logout({ logoutParams: { returnTo: window.location.origin } })
        }
      >
        <i className="fa-regular fa-door-open text-cosmic w-5 text-center" />
        Logout
      </ContextMenu.Item>
    </ContextMenu>
  );
};
